
.fw,
.fw *,
.fw *::before,
.fw *::after {
  box-sizing: border-box;
}

.fw {
  position: relative;
  background: #ffffff;
  color: #0a0a0a;
  font-family: "Rajdhani", Arial, sans-serif;
  overflow: hidden;
}

.fw-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.95fr);
  grid-template-rows: auto 1fr;
  column-gap: 5rem;
  row-gap: 1rem;
}

.fw-header {
  grid-column: 2;
  grid-row: 1;
  max-width: 560px;
}

.fw-body-wrap {
  grid-column: 2;
  grid-row: 2;
  max-width: 560px;
  align-self: start;
}

.fw-visual {
  grid-column: 1;
  grid-row: 1 / -1;
  align-self: center;
}

.fw-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 1.75rem;
}

.fw-eyebrow-mark {
  width: 28px;
  height: 2px;
  background: #de3431;
  border-radius: 2px;
  display: inline-block;
}

.fw-title {
  margin: 0 0 1.75rem 0;
  font-weight: 700;
  font-size: clamp(2rem, 3.5vw, 2.5rem);
  letter-spacing: -0.025em;
  line-height: 1.1;
  color: #0a0a0a;
}

.fw-title-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.fw-body {
  margin: 0 0 1.1rem 0;
  font-size: clamp(1rem, 1.1vw, 1.1rem);
  line-height: 1.6;
  color: #4a4a55;
  font-weight: 500;
}

.fw-body-lead {
  font-size: clamp(1.08rem, 1.25vw, 1.25rem);
  line-height: 1.55;
  color: #2a2a32;
  font-weight: 500;
}

.fw-body:last-of-type {
  margin-bottom: 0;
}

.fw-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.6rem;
  padding: 0.75rem 1.5rem;
  background: #de3431;
  color: #ffffff;
  text-decoration: none;
  font-family: "Rajdhani", Arial, sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 2px solid #de3431;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.fw-cta:hover,
.fw-cta:focus-visible {
  background: #0a0a0a;
  color: #ffffff;
  border-color: #0a0a0a;
}

.fw-cta-arrow {
  display: inline-block;
  transition: transform 0.2s ease;
}

.fw-cta:hover .fw-cta-arrow,
.fw-cta:focus-visible .fw-cta-arrow {
  transform: translateX(3px);
}

/* Framework grid */
.fw-stack {
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem;
  width: min(620px, 100%);
  padding: 0.25rem 0;
}

.fw-item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.8rem 0.85rem;
  border: 1px solid rgba(10, 10, 10, 0.08);
  background: #ffffff;
  border-radius: 10px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.fw-item:hover {
  border-color: rgba(222, 52, 49, 0.25);
  background: rgba(10, 10, 10, 0.012);
}

.fw-item-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
}

.fw .fw-item-logo img {
  max-width: 36px !important;
  max-height: 36px !important;
  width: auto !important;
  height: auto !important;
  min-width: 0 !important;
  min-height: 0 !important;
  object-fit: contain !important;
}

.fw-item-name {
  font-family: "Rajdhani", Arial, sans-serif;
  font-weight: 700;
  font-size: 1.02rem;
  color: #0a0a0a;
  letter-spacing: -0.005em;
}

@media (max-width: 960px) {
  .fw-inner {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 2rem;
    column-gap: 0;
  }
  .fw-header {
    grid-column: 1;
    grid-row: auto;
    order: 1;
    max-width: none;
  }
  .fw-visual {
    grid-column: 1;
    grid-row: auto;
    order: 2;
  }
  .fw-body-wrap {
    grid-column: 1;
    grid-row: auto;
    order: 3;
    max-width: none;
  }
}

@media (max-width: 540px) {
  .fw-title {
    font-size: clamp(1.9rem, 7vw, 2.5rem);
    margin-bottom: 1.25rem;
  }
  .fw-eyebrow { margin-bottom: 1.25rem; }
  .fw-stack {
    gap: 0.65rem;
  }
  .fw-item {
    gap: 0.75rem;
    padding: 0.7rem 0.65rem;
  }
  .fw-item-logo { width: 34px; height: 34px; }
  .fw .fw-item-logo img { max-width: 28px !important; max-height: 28px !important; }
  .fw-item-name { font-size: 0.95rem; }
}

@media (max-width: 360px) {
  .fw-stack {
    grid-template-columns: 1fr;
  }
}
